import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = {
  idStatement: number;
};

export const setStatementAsFailed = async (params: Params): Promise<void> => {
  const response = await customFetch(
    getM8AdminURL(`setStatementAsFailed?${createQueryString(params)}`),
    { method: 'POST' }
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
